import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMenuRepository } from '../menu/menu-repository';
import { HomeFallbackProps } from './home-fallback.component';

interface ViewProps {
    refresh: () => void;
}

const useHomeFallback = (props: HomeFallbackProps): ViewProps => {
    const navigate = useNavigate();
    const { isLoading, currentApp } = useMenuRepository();

    useEffect(() => {
        if (!isLoading) {
            if (currentApp) {
                navigate(`/${currentApp}/home`);
            }
        }
    }, [isLoading, currentApp]);

    const refresh = () => {
        navigate(0);
    };
    return { refresh };
};

export default useHomeFallback;
